import notification from "./notification.component";

const notificationModule = angular
  .module("app.components.notification", [])
  .component("notification", notification);

export default notificationModule;



// WEBPACK FOOTER //
// ./src/components/notification/notification.module.js